import { Mapper } from "../../../../base/utils/mapper";
import { ClientModel } from "../../../../domain/models/client/client.model";
import { ClientEntity } from "../entities/client.entity";


export class ClientImplementationRepositoryMapper extends Mapper<ClientEntity, ClientModel> {
    mapFrom(param: ClientEntity): ClientModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: ClientModel): ClientEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}